








































































































import Vue from "vue";
import firebase from "@firebase/app";
import { State, Getter, Mutation, Action } from "vuex-class";
import { User } from "@firebase/auth-types";

import { MUTATIONS, ACTIONS } from "@/models/vuex-types";
import { WishifyUser } from "@/models/wishify-user";
import { auth, db } from "@/firebaseConfig";
import { UserMenuItems } from "@/constants/user-menu-items";
import ViewTransition from "@/components/ViewTransition.vue";

// async loading of components not needed on initial load in one group chunk
const SignIn = () => import(
  /* webpackChunkName: "home-async-load" */ "@/components/SignIn.vue"
);
const Alerter = () => import(
  /* webpackChunkName: "home-async-load" */ "@/components/Alerter.vue"
);

import { Alert, AlertType } from "@/models/alert.ts";

import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {
    SignIn, Alerter, ViewTransition,
  },
})
export default class App extends Vue {
  // get everything we need from the store first
  @State private locale: string;
  @State private errors: string[];
  @State private currentUser: User;
  @State private isPageLoaded: boolean;
  @State private uiIsBlocked: boolean;
  @Mutation(MUTATIONS.SET_LOCALE) private SET_LOCALE: any;
  @Mutation(MUTATIONS.SET_CURRENT_USER) private SET_CURRENT_USER: any;
  @Mutation(MUTATIONS.SET_IS_PAGE_LOADED) private SET_IS_PAGE_LOADED: any;
  @Action(ACTIONS.SIGN_OUT_USER) private SIGN_OUT_USER: any;
  @Mutation(MUTATIONS.ADD_ALERT) private ADD_ALERT: any;
  @Mutation(MUTATIONS.SET_USERPROFILE) private SET_USERPROFILE: any;

  private isDrawerVisible = false;
  private isSignInVisible = false;
  private userMenuItems = UserMenuItems;
  private appVersion = process.env.VUE_APP_VERSION;
  private appEnv = process.env.VUE_APP_ENVIRONMENT;

  private async created() {

    // message for explorer users...
    const ua = window.navigator.userAgent;
    const isIe = /MSIE|Trident/.test(ua);
    if ( isIe ) {
      this.ADD_ALERT(new Alert(AlertType.INFO, "Tyto stránky nejsou optimalizovány pro INTERNET EXPLORER, prosím použijte moderní prohlížeč.", false));
    }

    // find and remove spinner after Vue is loaded
    let spinner = document.getElementById("spinner-container");
    if (spinner && !isIe) {
      spinner.className += "fade-out-spinner";
      setTimeout(() => spinner.parentElement.removeChild(spinner), 1000);
    }

    // check if user was redirected to our app from google auth sign in page
    // referrer not working for localhosts - always run this request in development env
    if ((document.referrer.substr(0, 35) === "https://accounts.google.com/signin/"
    || process.env.NODE_ENV === "development") && !this.isPageLoaded) {
      auth.getRedirectResult().then((result) => {
        const operationType = result.operationType;
        // this API can be used for sign-in, linking and reauthentication
        if (operationType === "signIn" && result.user) {
          // set user as current if any and only if after sign in operation
          this.setUser(result.user);
          this.ADD_ALERT(new Alert(AlertType.SUCCESS, this.$root.$i18n.t("sign_in_success").toString()));
        }
      }, (error) => {
        // // The provider's account email, can be used in case of
        // // auth/account-exists-with-different-credential to fetch the providers
        // // linked to the email:
        // const email = error.email;
        // // In case of auth/account-exists-with-different-credential error,
        // // you can fetch the providers using this:
        // if (error.code === "auth/account-exists-with-different-credential") {
        //   auth.fetchProvidersForEmail(email).then((providers) => {
        //     // The returned 'providers' is a list of the available providers
        //     // linked to the email address. Please refer to the guide for a more
        //     // complete explanation on how to recover from this error.
        //     // console.log(providers);
        //   });
        // }
      });
    }

    // set default locale from user profile
    if (this.currentUser) {
      await this.loadUserProfile();
    }

    // assigning locale from our store (TODO: users locale) to i18n
    this.$root.$i18n.locale = this.locale;
    // setting firebase language to locale
    auth.languageCode = this.locale;

    this.SET_IS_PAGE_LOADED(true);
  }

  private async loadUserProfile() {
    // get user profile from firebase so we can apply his preferences to the app
    // TODO: subscribe to profile changes
    let profileRef = db.collection("profiles").doc(this.currentUser.uid);
    let defaultAppLocale: string;
    try {
      let profileSnapshot = await profileRef.get();
      let userProfile = profileSnapshot.data();
      // set user profile in our store
      this.SET_USERPROFILE(userProfile);
      // set default locale from user profile
      defaultAppLocale = userProfile.locale || process.env.VUE_APP_I18N_LOCALE;
    } finally {
      this.SET_LOCALE(defaultAppLocale);
    }
  }

  private setUser(user: User) {
      let newUser: WishifyUser;
      if (user) {
        newUser = user;
        // this.$router.push("/profile");
      }
      this.SET_CURRENT_USER(newUser);
  }

  private onClick() {
    let selectedLocale = this.locale === "en" ? "cs" : "en";
    this.SET_LOCALE(selectedLocale);
  }

  private onSignedIn() {
    this.isSignInVisible = false;
    this.$router.push("/profile");
  }

  private async onSignedOut() {
    // await this.SIGN_OUT_USER();
    this.$router.push("/signed-out");
  }

  @Watch("locale")
  private updateLocale(newLocale: string) {
    this.$root.$i18n.locale = newLocale;
    // setting firebase language to current locale
    auth.languageCode = newLocale;
  }
}
